<template>
  <div class="hello">
    <div class="top">
      <span class="yqh">餐厅配置</span>
      <span class="ct" @click="invitation">邀请函配置</span>
    </div>
    <div class="body">
      <div class="title">餐厅信息：</div>
      <van-form ref="form">
        <van-field
          v-model="name"
          label="餐厅名称"
          placeholder="请输入"
          @input="change"
        />
        <div class="xian"></div>
        <div v-show="!name" class="tishi">请填写餐厅名称</div>
        <div class="time">
          <van-field
            v-model="RestaurantAddress"
            label="餐厅地址"
            placeholder="请选择省市区"
            readonly
            @click="open"
            @input="change"
          />
          <div class="icon" @click="open">
            <img src="../assets/素材/向右1 (6).png" alt="" />
          </div>
        </div>
        <div class="xian"></div>
        <div v-show="!RestaurantAddress" class="tishi">请选择餐厅地址</div>
        <!-- <div class="title2">邀请致辞</div>
        <div class="box">
          <van-field
          v-model="message"
          rows="2"
          autosize
          type="textarea"
          maxlength="500"
          placeholder="请输入，并请自行排版换行"
          :rules="[{ required: true, message: '请填写邀请致辞' }]"
          show-word-limit
        />
        </div> -->
        <van-field
          v-model="address"
          label="详细地址"
          placeholder="请输入"
          @input="change"
        />
        <div class="xian"></div>
        <div v-show="!address" class="tishi">请填写详细地址</div>
        <van-field
          v-model="linkman"
          label="联系人"
          class="lxr"
          placeholder="请输入"
          @input="change"
        />
        <div class="xian"></div>
        <div v-show="!linkman" class="tishi">请填写联系人</div>
        <van-field
          v-model="phone"
          label="联系电话"
          placeholder="请输入"
          @input="change"
        />
        <div class="xian"></div>
        <div v-show="!phone" class="tishi">请填写联系电话</div>
        <div class="title3">餐厅环境：</div>
        <div class="box3">
          <van-uploader :after-read="afterRead" :max-count="10" />
          <div class="img" v-for="(item, index) in imgs" :key="index">
            <img :src="item" alt="" />
            <div @click="del(index)" class="del">X</div>
          </div>
        </div>
      </van-form>
    </div>
    <button :disabled="isButtonDisabled" class="create2" @click="create">提交</button>
    <van-popup v-model="currentDate" position="bottom">
      <van-area
        title="请选择所在地区"
        value="110101"
        :area-list="areaList"
        @confirm="onConfirm"
        @cancel="currentDate = false"
      />
    </van-popup>
    <!-- <van-area
      title="请选择所在地区"
      v-show="currentDate"
      :value="RestaurantAddress"
      :area-list="areaList"
      @confirm="onConfirm"
      @cancel="currentDate = false"
    /> -->
  </div>
</template>

<script>
import { areaList } from '@vant/area-data';
import { Toast } from 'vant';
const axios = require('axios');
// import Vue from 'vue'


export default {
  name: "InvitationConfiguration",
  props: {
    msg: String,
  },
  data() {
    return {
      id: "",
      name: "",
      RestaurantAddress: "",
      address: "",
      linkman: "",
      phone: "",
      imgs: [],
      img: [],
      areaList: areaList,
      currentDate: false,
      isButtonDisabled: true,
    };
  },
  created() {
    this.getRestaurants()
    console.log(this.img,787);
  },
  methods: {
    open() {
      this.currentDate = true;
    },
    change() {
      // this.imgs = []
    },
    invitation() {
      this.$router.push("/invitation");
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log(file);
      if(file.file) {
        Toast('上传成功');
        this.imgs.push(file.content)
        // this.$globalData.img.push(file)
        this.img.push(file.file)
      }
      console.log(this.img,888);
    },
    del(index) {
      this.imgs.splice(index,1)
      this.img.splice(index,1)
      console.log(this.img)
    },
    async getRestaurants2() {
      const list = await this.$baseUrl.collection("restaurant").getFirstListItem("", {sort: "-created",})
      localStorage.setItem('data',JSON.stringify(list))
    },
    async getRestaurants() {
      const list = await this.$baseUrl.collection("restaurant").getFirstListItem("", {sort: "-created",})
      console.log(list);
      this.name = list.title
      this.RestaurantAddress = list.province+'/'+list.city+'/'+list.district
      this.address = list.address
      this.linkman = list.contact_person
      this.phone = list.contact_phone
      this.id = list.id
      const img = list.photos
      // this.img = list.photos
      const options = {}
      this.imgs = []
      img.forEach(item => {
        const url = this.$baseUrl.files.getUrl(list, item, options);
        this.imgs.push(url)
      })
      // const data = JSON.parse(localStorage.getItem('dataImg'))
      console.log(this.imgs);
      // if(JSON.stringify(this.imgs) === JSON.stringify(data)) {
      //   console.log(333)
      //   // this.img = img3;
      //   this.isButtonDisabled = false
      //   return
      // }

      // 假设我们有一个远程文件URL
      const url = this.imgs;
      // 创建一个数组来保存所有的Promise  
      const promises = url.map(item => {  
        return axios.get(item, {  
          responseType: 'blob', // 指定返回类型为Blob  
        })  
        .then(response => {  
          if (response.status === 200) {  
            const blob = new Blob([response.data], { // 创建Blob对象  
              type: response.headers['content-type'] || '' // 设置正确的MIME类型  
            });  
              
            // 现在从Blob创建一个File对象  
            let file = new File([blob], item, {type: blob.type});  
              
            return file; // 返回File对象  
          } else {  
            return Promise.reject(new Error(`Error fetching the file: ${response.statusText}`));  
          }  
        })  
        .catch(error => Promise.reject(new Error(`Axios Error: ${error}`)));  
      });  
        
      // 使用Promise.all等待所有的请求都完成  
      Promise.all(promises)  
        .then(files => {  
          // 这里files是一个包含所有File对象的数组  
          // 你可以在这里进行上传操作  
          this.img = files; // 假设this.img是你用来存储File对象的数组
          console.log(this.img);
          localStorage.setItem('dataImg', JSON.stringify(this.img));
          this.isButtonDisabled = false
        })  
        .catch(error => {  
          // 如果任何一个请求失败，这里会捕获到错误  
          console.error('Error fetching files:', error);  
        });

      // // 使用axios获取资源，并指定responseType为'blob'
      // url.forEach(item => {
      //   axios.get(item, {
      //   responseType: 'blob', // 指定返回类型为Blob
      // })
      // .then(response => {
      //   if (response.status === 200) {
      //     const blob = new Blob([response.data], { // 创建Blob对象
      //       type: response.headers['content-type'] || '' // 设置正确的MIME类型
      //     });
          
      //     // 现在从Blob创建一个File对象
      //     let file = new File([blob], item, {type: blob.type});

      //     // 可以像操作本地File对象一样处理这个远程生成的File对象
      //     // uploadFile(file);
      //     console.log(file,1000)
      //     this.img.push(file)
      //   } else {
      //     console.error('Error fetching the file:', response.statusText);
      //   }
      // })
      // .catch(error => console.error('Axios Error:', error));
      // })
    },
    async pime1() {
      this.RestaurantAddress = this.RestaurantAddress.split('/')
      // const img = []
      // const storedImages = this.$globalData.img
      // img.push(...storedImages.map(item => item.file))
      const bodyParams = {
          title: this.name, // 餐馆名称
          province: this.RestaurantAddress[0],
          city: this.RestaurantAddress[1],
          district: this.RestaurantAddress[2],
          address: this.address,
          contact_person: this.linkman,
          contact_phone: this.phone,
          photos: this.img
        }
        const recordId = this.id
        console.log(this.img,777)
      const options = {}
      const rs = await this.$baseUrl.collection("restaurant").update(recordId, bodyParams, options);
      console.log(rs)
    },
    async pime2() {
      this.RestaurantAddress = this.RestaurantAddress.split('/')
      // const img = []
      // const storedImages = this.$globalData.img
      console.log(this.img[5],777)
      // img.push(...storedImages.map(item => item.file))
      const rs = await this.$baseUrl.collection("restaurant").create({
        title: this.name, // 餐馆名称
        province: this.RestaurantAddress[0],
        city: this.RestaurantAddress[1],
        district: this.RestaurantAddress[2],
        address: this.address, // 地址
        contact_person: this.linkman, // 联系人
        contact_phone: this.phone, // 联系人电话
        photos: this.img, // 图片
      });
      localStorage.setItem('data',JSON.stringify(rs))
      console.log(rs);
    },
    async create() {
        this.isButtonDisabled = true; // 禁用按钮
        if(!this.name || !this.address || !this.RestaurantAddress || !this.linkman || !this.phone){
          return
        }
        try {  
          await this.pime2();  
          Toast('保存成功');     
          // 等待一段时间再执行invitation方法  
          await setTimeout(() => {
            this.invitation();  
          }, 500);  
        } catch (error) {  
          // 处理错误  
          Toast('保存失败');  
        } finally {  
          // this.isButtonDisabled = false; // 启用按钮  
        }  
    },
    onConfirm(value) {
      console.log(value)
      this.RestaurantAddress = value.map((item) => item.name).join('/');
      this.currentDate = false
    }
  }
};
</script>
<style>
.top {
  width: 100%;
  height: 100px;
  background: linear-gradient(
    225deg,
    rgb(205, 165, 130) 0%,
    rgb(170, 128, 92) 100%
  );
  display: flex;
  align-items: center;
}
.yqh {
  flex: 1;
  text-align: center;
  margin-left: 165px;
  color: rgb(255, 255, 255);
  font-size: 32px;
}
.ct {
  width: 137px;
  margin-right: 28px;
  color: rgb(255, 255, 255);
  font-size: 26px;
}
.body {
  padding: 0 45px;
}
.body .title {
  margin: 38px 0 0 14px;
  color: rgb(170, 128, 92);
  font-size: 32px;
}
.body .title2 {
  color: rgb(105, 105, 105);
  margin: 43px 0 22px 14px;
  font-size: 26px;
}
.body .title3 {
  margin: 66px 0 0 14px;
  color: rgb(170, 128, 92);
  font-size: 32px;
}
.van-cell {
  overflow: visible;
  padding: 0;
  height: 50px;
  margin-top: 35px;
  align-items: center;
}
.van-cell::after {
  display: none;
}
.van-field__label {
  margin-right: 46px !important;
  margin-left: 14px !important;
  width: auto !important;
}
.lxr .van-field__label {
  margin-right: 72px !important;
  margin-left: 14px !important;
  width: auto !important;
}
.van-field__label span {
  font-size: 26px;
  color: rgb(105, 105, 105);
}
.van-cell__value {
  height: 40px;
}
.van-field__error-message {
  font-size: 26px !important;
}
.van-field__body {
  height: 95%;
}
.van-field__control {
  font-size: 26px;
  color: rgb(105, 105, 105);
}
.xian {
  height: 1px;
  background: rgb(219, 219, 219);
  margin-top: 15px;
}
.van-form {
  position: relative;
}
.time {
  position: relative;
}
.time .icon {
  position: absolute;
  top: 5px;
  right: 15px;
  width: 35px;
  height: 35px;
}
.time .icon img {
  width: 100%;
  height: 100%;
}
.box {
  border-radius: 10px;
  height: 250px;
  background: rgb(243, 243, 243);
}
.box .van-cell {
  background-color: transparent;
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
}
.box .van-cell .van-field__value {
  width: 100%;
  height: 100%;
}
.box .van-cell .van-field__value .van-field__control {
  width: 100%;
  height: 100% !important;
  overflow-y: auto;
}
.van-field__word-limit {
  position: absolute;
  right: 10px;
  bottom: 10px;
  color: rgb(219, 219, 219) !important;
  font-size: 24px !important;
}
.create2 {
  width: 654px;
  height: 80px;
  position: fixed;
  border: none;
  bottom: 69px;
  left: 48px;
  /* margin: 93px auto 69px; */
  border-radius: 50px;
  box-shadow: 5px 10px 15px 0px rgba(170, 128, 92, 0.4);
  background: linear-gradient(
    -37.26deg,
    rgb(205, 165, 130) 8.033%,
    rgb(170, 128, 92) 96.701%
  );
  color: rgb(255, 255, 255);
  font-size: 32px;
  text-align: center;
  line-height: 80px;
}
.box3 {
  padding: 25px 0 0 14px;
  display: flex;
  flex-wrap: wrap;
}
.van-uploader__upload,
.van-uploader__preview-image {
  width: 125px;
  height: 125px;
}
.van-uploader__upload .van-icon-photograph {
  font-size: 45px !important;
}
.van-uploader__preview-delete {
  width: 30px !important;
  height: 30px !important;
}
.van-uploader__preview-delete .van-uploader__preview-delete-icon {
  font-size: 30px !important;
}
.van-picker__toolbar,
.van-picker__toolbar .van-picker__title {
  height: 80px;
}
.van-picker__toolbar .van-picker__title {
  line-height: 90px;
}
.van-ellipsis,
.van-picker__cancel,
.van-picker__confirm {
  font-size: 26px;
}
.van-toast__text {
  width: 120px !important;
  height: 70px !important;
  font-size: 22px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.tishi {
  color: #ee0a24;
  font-size: 24px;
  margin-left: 14px;
}
.img {
  width: 120px;
  height: 120px;
  margin: 0 10px 10px 0;
  position: relative;
}
.box3 .img img {
  width: 100%;
  height: 100%;
}
.box3 .img .del {
  position: absolute;
  top: 0;
  right: 0;
  width: 35px;
  height: 35px;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  color: #fff;
  border-bottom-left-radius: 15px;
}
</style>
